var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticClass:"editor"},[_c('div',{staticClass:"editor-words__limit"},[_vm._v(_vm._s(_vm.text.length)+"/10000")])])
}
var staticRenderFns = []

export { render, staticRenderFns }